<template>
    <div id="content" class="container-medium">
        <p class="text-big text-gray">404 - Not Found</p>
    </div>
</template>

<script>

export default {
  head: {
    title: function () {
      return {
        inner: 'Page not found'
      }
    },
    meta: [
      {name: 'description', content: '404 - Page not found', id: 'meta-description'}
    ]
  },
}

</script>
